import { last } from 'ramda';
import { SERVICE_NAME } from '../../../constants';

export const getMetaPageLink = (page) => `${SERVICE_NAME}_[${page}]`;

export const getPageParams = (path, params = {}) => {
  const paramName = last(path.split(':'));
  const pageParam = params[paramName];

  return pageParam ? { name: pageParam } : {};
};
